import UserForm from './UserForm';

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/forms/UserForm/index.jsx